import { CommonModule } from '@angular/common';
import { Component } from '@angular/core';

@Component({
  selector: 'app-why-choose-us-component',
  standalone: true,
  imports: [CommonModule],
  templateUrl: './why-choose-us-component.component.html',
  styleUrl: './why-choose-us-component.component.scss'
})
export class WhyChooseUsComponentComponent {

}
